import React, { useEffect, useState } from "react";
import { FaPhone } from "react-icons/fa";
import TwilioPhoneDrawer from "./TwilioPhoneDrawer";
import { useSelector, useDispatch } from "react-redux";
import { setOpen, close } from "../../features/twilioPhoneSlice";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";

const TwilioPhone = ({ hideButton = false }) => {
  const dispatch = useDispatch();
  const { open, client, quoteId } = useSelector((state) => state.twilioPhone);
  const user = useSelector((state) => state.auth.user);
  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION";
  
  const handleOpenPhone = () => {
    dispatch(setOpen(true));
  };

  const handleClosePhone = () => {
    dispatch(close());
  };

  const [services, setServices] = useState([]);

  const getServices = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?limit=0`);
      setServices(response.data.docs);
    } catch (error) {
      return false
    }
  };

  useEffect(() => {
    if (quoteId) {
      getServices();
    }
  }, [quoteId]);

  return (
    <>
      {isAdmin && (
        <button
          className={`fixed bottom-[8.5rem] right-6 z-50 w-12 h-12 flex items-center justify-center rounded-full shadow-lg transition-all duration-300 ${
            hideButton
              ? 'opacity-0 pointer-events-none' 
              : 'bg-purple-600 hover:bg-purple-700 hover:shadow-xl hover:scale-105'
          } text-white`}
          onClick={handleOpenPhone}
        >
          <FaPhone className="text-lg" />
        </button>
      )}
      
      <TwilioPhoneDrawer 
        setOpen={(value) => dispatch(setOpen(value))} 
        open={open} 
        onClose={handleClosePhone}
        client={client}
        quoteId={quoteId}
        services={services.length > 0 ? services : []}
      />
    </>
  );
};

export default TwilioPhone;
